﻿export class DnDUtilities
{
    public startSetDragImageListener(className: string, dragElementId: string, xOffset: number = 0, yOffset: number = 0)
    {
        if (className != undefined && dragElementId != undefined)
        {
            let targetEl = document.getElementById(dragElementId);
            let elements = document.getElementsByClassName(className);
            for (let i = 0; i < elements.length; ++i)
            {
                let em = elements[i];

                em.addEventListener("dragstart", function (e)
                {
                    (<any>targetEl).style.visibility = 'visible';
                    (<any>e).dataTransfer.setDragImage(targetEl, xOffset, yOffset);
                }, false);
            }
        }
    }

    static timers = [];

    public autoScrollStart(id: string, down: boolean)
    {
        let that = this;
        if (DnDUtilities.timers[id] == undefined)
        {
            DnDUtilities.timers[id] = setInterval(function ()
            {
                let el = document.getElementById(id);

                if (el != null)
                {
                    let height = el.clientHeight;
                    let amount = (height * 0.25) * (down ? -1 : 1);

                    el.scroll({ top: el.scrollTop + amount, behavior: "smooth" });
                }
                else
                {
                    that.autoScrollEnd(id);
                }
            }, 200);
        }
    }

    public autoScrollEnd(id: string)
    {
        if (DnDUtilities.timers[id] != undefined)
        {
            clearInterval(DnDUtilities.timers[id]);
            delete DnDUtilities.timers[id];
        }
    }
}